<sc-flex vertical fitHeight stretchContent class="no-field-space add-catalog-dialog">

    <sc-dialog-title>
      <sc-dictionary-label dictionaryKey="erp.ui.add-catalognode.title"></sc-dictionary-label>
    </sc-dialog-title>

    <sc-padding>
        <div style="width: 450px;">
            <sc-dictionary-field class="name-input" [model]="name" [maxlength]="255" defaultLabel="Name" [required]="true"
                labelDictionaryKey="erp.entity.catalognode.name" (dictionaryChanged)="onNameChanged($event)">
            </sc-dictionary-field>
        </div>
    </sc-padding>

    <sc-actionbar>
        <sc-content-spacer grow></sc-content-spacer>
        <button mat-stroked-button (click)="onClose()">
          <sc-dictionary-label dictionaryKey="erp.ui.add-catalognode.action.cancel"></sc-dictionary-label>
        </button>
        <sc-content-spacer></sc-content-spacer>
        <button mat-flat-button (click)="onConfirm()" [disabled]="confirmDisabled()">
          <sc-dictionary-label dictionaryKey="erp.ui.add-catalognode.action.confirm"></sc-dictionary-label>
        </button>
    </sc-actionbar>
</sc-flex>
